var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"background-color":"transparent","position":"relative","z-index":"100"},attrs:{"elevation":"0"}},[_c('a',{attrs:{"href":_vm.$router.resolve({
        name: 'actuItem',
        params: { slug: _vm.slug, id: _vm.id }
      }).href}},[_c('div',[_c('v-img',{attrs:{"height":"250","src":_vm.imgUrl}})],1),_c('h6',{staticClass:"text-h5 text-center black--text mt-7",domProps:{"textContent":_vm._s(_vm.title)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }